import React from 'react'
import FooterInfoLayout from '@layouts/footer-info-layout'
import { TermsAndConditionsContent } from './terms-and-conditions'
import { VStack } from '@chakra-ui/react'

const Careers = () => {
  return (
    <FooterInfoLayout title="Careers">
      <VStack w={'100%'} spacing={7}>
        <TermsAndConditionsContent>
          Do you have drive and ambition? Then join JML – a global innovative
          consumer product brand and one of the fastest growing sales and
          marketing companies. We have consistently delivered exceptional sales
          through the combination of great products, first class service and
          heavyweight TV advertising.
        </TermsAndConditionsContent>
        <TermsAndConditionsContent>
          If you are interested in joining a world leading innovative consumer
          product brand then send us an email with your CV to{' '}
          <u>enquiries@jmldirect.com.sg</u> now!
        </TermsAndConditionsContent>
        <TermsAndConditionsContent title="Job Opportunities :">
          No openings currently
        </TermsAndConditionsContent>
        <TermsAndConditionsContent>
          <TermsAndConditionsContent>
            Contact us for further details.
          </TermsAndConditionsContent>
          <TermsAndConditionsContent>
            NO AGENCIES PLEASE
          </TermsAndConditionsContent>
        </TermsAndConditionsContent>
      </VStack>
    </FooterInfoLayout>
  )
}

export default Careers
